<template>
    <!-- Componente antiguo para mostrar la cotización de cetelem (no se utiliza) -->
    <div class="cetelem-quotation bg-light-gray2 py-8 mt-10 px-2">
        <h3 class="font-medium text-xl lg:text-2xl text-center px-1">Resumen de tu Simulación CETELEM</h3>
        <!-- <div class="text-center mt-6">
        <p class="text-lg font-medium">Elige tu Plan</p>
        <div class="flex flex-wrap md:flex-no-wrap justify-center mt-4">
            <div class="mb-4 md:mb-0" v-for="(plan, index) in cetelemQuotation.planes" :key="index">
                <label class="radio-container md:ml-16">
                    <div>
                        <p class="mt-2">{{plan.plan}}</p>
                    </div>
                    <input type="radio" name="plan" v-model="planSelected" :value="index">
                    <span class="radio-checkmark"></span>
                </label>
            </div>
        </div>
    </div> -->
        <div class="text-center mt-6">
            <p class="text-lg font-medium">Elige tu Aseguradora<span class="text-xs align-top">1</span></p>
            <div class="flex flex-wrap md:flex-no-wrap justify-center mt-8">
                <div
                    class="mb-4 md:mb-0"
                    v-for="(insurance, index) in insurances"
                    :key="index"
                >
                    <label
                        class="radio-container md:ml-16"
                        v-if="insurance.terms[instSelected]"
                    >
                        <div>
                            <div class="h-6">
                                <img
                                    class="mx-auto"
                                    :src="`${insurance.urlLogo}`"
                                    :alt="insurance.aseguradora"
                                >
                            </div>
                            <p class="mt-2">${{ formatPrice(insurance.terms[instSelected].pagoMensual1) }}</p>
                        </div>
                        <input
                            type="radio"
                            name="insurance"
                            v-model="insuSelected"
                            :value="index"
                        >
                        <span class="radio-checkmark"></span>
                    </label>
                </div>
            </div>
        </div>
        <div class="flex flex-wrap md:flex-no-wrap justify-around mt-4 md:mt-12 px-6 lg:px-10">
            <div class="text-center w-full md:w-1/3">
                <p class="font-medium">Plazo</p>
                <img
                    class="h-16 mt-4 lg:mt-6 mx-auto"
                    :src="`${url}/images/icons/speedometer_black_icon.png`"
                    alt="Velocimetro"
                >
                <p class="text-2xl lg:text-3xl mt-4 lg:mt-6">{{ instalments[instSelected] }} MESES</p>
                <p class="mt-2 lg:mt-6 lg:text-lg">Tasa de Interés <span class="text-xs align-top">2</span> {{ tasa }}%
                </p>
            </div>
            <div class="line hidden md:block border-solid border-l border-black h-56 mt-2"></div>
            <div class="text-center w-full md:w-1/3 mt-6 md:mt-0 md:px-6 lg:px-0">
                <p class="font-medium">Pago Mensual <span class="text-xs align-top">1</span></p>
                <img
                    class="h-16 mt-4 lg:mt-6 mx-auto"
                    :src="`${url}/images/icons/speedometer_black_icon.png`"
                    alt="Velocimetro"
                >
                <p class="text-2xl lg:text-3xl mt-4 lg:mt-6">${{ formatPrice(pagoMensual) }}</p>
                <p class="mt-2 lg:mt-6 lg:text-lg">CAT promedio sin IVA <span class="text-xs align-top">3</span>
                    {{ cat }}%</p>
            </div>
            <div class="line hidden md:block border-solid border-r border-black h-56 mt-2"></div>
            <div class="text-center w-full md:w-1/3 mt-6 md:mt-0">
                <p class="font-medium">Financiamiento</p>
                <img
                    class="h-16 mt-4 lg:mt-6 mx-auto"
                    :src="`${url}/images/icons/speedometer_black_icon.png`"
                    alt="Velocimetro"
                >
                <p class="text-2xl lg:text-3xl mt-4 lg:mt-6">${{ formatPrice(financiamiento) }}</p>
                <div class="mt-2 lg:mt-4 lg:text-lg leading-tight">
                    <p>Total a Pagar</p>
                    <p>${{ formatPrice(totalAPagar) }}</p>
                </div>
            </div>
        </div>
        <div class="px-4 sm:px-6 lg:px-20">
            <div class="mt-6 sm:mt-8 text-sm sm:text-base">
                <p>1. Pago mensual con IVA con seguro de vehículo incluido.</p>
                <p>2. Tasa de interés anual.</p>
                <p>3. CAT promedio sin IVA “informativo”.</p>
            </div>
            <div class="flex flex-wrap md:flex-no-wrap mt-4 md:mt-6">
                <p class="text-sm sm:text-base">*Los montos y las tasas pueden variar dependiendo de tu historial
                    crediticio.</p>
                <div class="mt-6 md:mt-0 flex md:ml-10 lg:ml-16">
                    <label class="checkbox-container">
                        <input
                            type="checkbox"
                            v-model="cetelemTerms"
                        >
                        <span class="checkmark"></span>
                    </label>
                    <p class="text-sm sm:text-base">Acepto los <a
                            class="underline"
                            target="_blank"
                            href="https://www.cetelem.com.mx/terminos-y-condiciones.html"
                        >Términos y condiciones</a> de la Política de privacidad</p>
                </div>
            </div>
            <div class="text-center">
                <button
                    class="w-48 sm:w-88 hyundai-button sm:text-base mx-auto my-8"
                    @click="chargeCetelemForm()"
                >Obtén tu <span class="font-medium">Tabla de Pagos<br class="sm:hidden"> (Amortización)</span></button>
            </div>
            <div class="text-center mt-6 text-sm">
                <p>La información que contiene el “Cotizador Cetelem” del sitio web, tiene como objetivo principal
                    proporcionar a los visitantes, en una forma general, información sobre los productos y servicios de
                    Cetelem, S.A. de C.V., SOFOM, E.R., (en lo sucesivo “Cetelem”), pero esto no implica ni garantiza
                    que la información presentada pueda satisfacer los requisitos de precisión, detalle o exactitud
                    requerida por sus visitantes ya que no constituyen una oferta por parte de Cetelem, por lo que la
                    cotización resultante puede variar al momento de la firma del contrato correspondiente.</p>
                <div v-show="showMoreDisc">
                    <p class="mt-2">Por otra parte, cualquier propuesta, oferta, sugerencia o en general cualquier tipo
                        de información que Cetelem reciba por medio de correo electrónico, teléfonos, y/o cualquier
                        otro medio de comunicación indicado en este sitio web, no implicará la aceptación, compromiso
                        u obligación hacia el remitente. Asimismo, dichos medios de comunicación no serán medios
                        aceptados por Cetelem para la recepción de cualquier tipo de notificación judicial o
                        extrajudicial, demandas, emplazamientos o requerimientos de autoridad.</p>
                    <p class="mt-2">Los modelos, versiones y precios que se muestran en el “Cotizador Cetelem” del sitio
                        web, pueden diferir de los modelos, versiones y precios ofrecidos por la red de distribuidores
                        autorizados Hyundai, por lo que Cetelem no se responsabiliza por la disponibilidad ni la calidad
                        del vehículo seleccionado. De igual modo, las promociones de financiamiento de Cetelem podrán
                        variar según la marca, modelo y versión, para mayor información consulta a los distribuidores
                        autorizados Hyundai.</p>
                </div>
                <p
                    class="underline cursor-pointer mt-2"
                    @click="showMoreDisc = showMoreDisc ? false : true"
                >{{ !showMoreDisc ? 'Ver más' : 'Ver menos' }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
    props: [
        "instalments",
        "instSelected",
        "cetelemQuotation",
        "versionId",
        "subsidiary",
        "isIframe",
    ],
    data() {
        return {
            // Variable para almacenar la url base del sitio
            url: $(".url").text(),
            // Variable para almacenar el slug del dealer correspondiente
            webpage: $(".webpage").text(),
            // Variable para determinar el plazo seleccionado
            insuSelected: 0,
            // Variable para seleccionar el plan seleccionado (no utilizado)
            planSelected: 0,
            // Variable para determinar si mostrar más información
            // del disclaimer
            showMoreDisc: false,
            // Variable para determinar si se aceptan los
            // términos y condiciones
            cetelemTerms: false,
        };
    },
    watch: {
        instSelected: function (val) {
            // if (this.cetelemQuotation.planes && !this.insurances) {
            //     this.$emit('bad-instalment')
            // }
            // this.insuSelected = 0
            if (this.insurances) {
                for (const ins in this.insurances) {
                    if (!this.insurances[ins].terms[this.instSelected]) {
                        this.insuSelected++;
                    }
                }
                if (this.insuSelected > 2) {
                    this.$emit("bad-instalment");
                }
            }
        },
    },
    methods: {
        formatPrice(price) {
            return parseFloat(price)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        },
        chargeCetelemForm() {
            if (this.cetelemTerms) {
                let quotData = {
                    pagoMensual: this.pagoMensual,
                    montoTotal: this.financiamiento,
                    totalAPagar: this.totalAPagar,
                    idAseguradora:
                        this.insurances[this.insuSelected].idAseguradora,
                    idPlan: this.cetelemQuotation.planes[this.planSelected]
                        .idPlan,
                };
                this.$emit("charge-cetelem-form", quotData);
            } else {
                Swal.fire({
                    icon: "error",
                    title: '<h3 class="text-2xl leading-tight font-medium">Datos requeridos</h3>',
                    html: "<p>Debes aceptar los Términos y Condiciones</p>",
                    confirmButtonText: "Aceptar",
                    customClass: {
                        confirmButton:
                            "text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2",
                    },
                    buttonsStyling: false,
                });
            }
        },
        getPagoMensual(idx) {
            return this.insurances[idx].terms[this.instSelected].pagoMensual1;
        },
        // redirectForm() {
        //     if (this.cetelemTerms) {
        //         axios.post(`${this.url}/cetelem/redirect-form`,
        //         {
        //             term            : this.instalments[this.instSelected],
        //             idAseguradora   : this.insurances[this.insuSelected].idAseguradora,
        //             webpage         : this.webpage,
        //             versionId       : this.versionId,
        //             pagoMensual     : this.pagoMensual,
        //             montoTotal      : this.montoTotal,
        //             totalAPagar     : this.totalAPagar,
        //         })
        //         .then(resp => {
        //             if (resp.data.success) {
        //                 if (this.isIframe === 'true') {
        //                     window.location.href = `${this.url}/iframe/cotizacion/${this.subsidiary}/${this.versionId}/cetelem-form`
        //                 }
        //                 else {
        //                     window.location.href = `${this.url}/${this.webpage}/modelos/cotizacion/${this.versionId}/cetelem-form`
        //                 }
        //             }
        //         })
        //         .catch(err => {
        //             console.log('/cetelem/redirect-form', err)
        //         })
        //     }
        //     else {
        //         Swal.fire({
        //             icon: 'error',
        //             title: '<h3 class="text-2xl leading-tight font-medium">Datos requeridos</h3>',
        //             html: '<p>Debes aceptar los Términos y Condiciones</p>',
        //             confirmButtonText: 'Aceptar',
        //             customClass: {
        //                 confirmButton: 'text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2',
        //             },
        //             buttonsStyling: false
        //         })
        //     }
        // }
    },
    computed: {
        insurances() {
            if (this.cetelemQuotation.planes) {
                // let insurances = this.cetelemQuotation.planes[0].termsXAseguradora
                // if (insurances[this.insuSelected].terms[this.instSelected]) {
                //     return insurances
                // }
                return this.cetelemQuotation.planes[this.planSelected]
                    .termsXAseguradora;
            }
            return null;
        },
        tasa() {
            return this.insurances
                ? this.insurances[this.insuSelected].terms[this.instSelected]
                    .tasa
                : 0;
        },
        pagoMensual() {
            return this.insurances
                ? this.insurances[this.insuSelected].terms[this.instSelected]
                    .pagoMensual1
                : 0;
        },
        cat() {
            return this.insurances
                ? this.insurances[this.insuSelected].terms[this.instSelected]
                    .cat
                : 0;
        },
        financiamiento() {
            // return this.insurances ? this.insurances[this.insuSelected].terms[this.instSelected].montoTotal : 0
            return this.insurances ? this.cetelemQuotation.montoFinanciar : 0;
        },
        totalAPagar() {
            return this.insurances
                ? this.insurances[this.insuSelected].terms[this.instSelected]
                    .montoTotal
                : 0;
        },
    },
};
</script>

<style lang="scss">
.cetelem-quotation {

    /* Customize the label (the container) */
    .checkbox-container {
        display: block;
        position: relative;
        padding-left: 2.5rem;
        /* margin-bottom: 12px; */
        cursor: pointer;
        /* font-size: 22px; */
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .checkbox-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 1.5rem;
        width: 1.5rem;
        background-color: #fff;
        border: 1px solid #444444;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .checkbox-container input:checked~.checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .checkbox-container .checkmark:after {
        left: 7px;
        top: 1px;
        width: 10px;
        height: 18px;
        border: solid #00aad2;
        border-width: 0 4px 4px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .checkbox-container .checkmark:after {
        left: 7px;
        top: 1px;
        width: 10px;
        height: 18px;
        border: solid #000;
        border-width: 0 4px 4px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    /** Radio Button **/
    /* Customize the label (the container) */
    .radio-container {
        display: block;
        position: relative;
        padding-left: 2.5rem;
        /* margin-bottom: 12px; */
        cursor: pointer;
        /* font-size: 22px; */
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default radio button */
    .radio-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom radio button */
    .radio-checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 1.5rem;
        width: 1.5rem;
        background-color: #ededed;
        border-radius: 50%;
        border: 1px solid #000;
    }

    /* On mouse-over, add a grey background color */
    /* .radio-container:hover input ~ .radio-checkmark {
    background-color: #ccc;
    } */

    /* When the radio button is checked, add a blue background */
    /* .radio-container input:checked ~ .radio-checkmark {
    background-color: #ededed;
    } */

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .radio-checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    .radio-container input:checked~.radio-checkmark:after {
        display: block;
    }

    /* Style the indicator (dot/circle) */
    .radio-container .radio-checkmark:after {
        top: 5px;
        left: 5px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #000;
    }
}
</style>